import { render, staticRenderFns } from "./TicketReplicasDialog.vue?vue&type=template&id=245ea5a0&"
import script from "./TicketReplicasDialog.vue?vue&type=script&lang=js&"
export * from "./TicketReplicasDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports